var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"loadMoreTrigger",staticClass:"footer-load-placeholder"},[(_vm.more)?_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm.$t('enterprise.loading')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }